import { string, object, SchemaOf } from 'yup'

export interface IEditPasswordSchema {
    currentPassword: string
    newPassword: string
    newPasswordConf: string
}

const editPasswordSchema: SchemaOf<IEditPasswordSchema> = object().shape({
    currentPassword: string().required('Preencha o campo com sua senha atual.').max(200, 'Máx 200 caracteres'),
    newPassword: string().required('Preencha o campo com sua nova senha.').min(6, 'Min 6 caracteres').max(20, 'Máx 20 caracteres'),
    newPasswordConf: string().required('Confirme sua nova senha.').min(6, 'Min 6 caracteres').max(20, 'Máx 20 caracteres'),
})

export default editPasswordSchema
